// tslint:disable:max-line-length

import React from 'react';

export const UtilityHelpOutline = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14.5c-3.6,0-6.5-2.9-6.5-6.5S4.4,1.5,8,1.5s6.5,2.9,6.5,6.5 S11.6,14.5,8,14.5z" />
      <rect x="7.2" y="10.8" width="1.7" height="1.7" />
      <path d="M8,3.5c-1.1,0-1.9,0.4-2.4,1.1C5.3,5.3,5.3,5.9,5.3,6.2v0.4h1.6V6.2c0-0.2,0-0.5,0.1-0.8C7,5.3,7.2,5.1,8,5.1 c1.1,0,1.2,0.4,1.1,0.6c0,0.6-0.3,0.8-0.6,1.1L8.4,6.9C8,7.3,7.2,8,7.2,9.4v0.5h1.6V9.4c0-0.7,0.3-0.8,0.7-1.2 c0.4-0.4,1.2-1.1,1.2-2.4c0-0.5-0.3-1.2-0.7-1.6C9.6,3.8,8.9,3.5,8,3.5z" />
    </svg>
  );
};
